import { Grid, makeStyles, useMediaQuery } from "@material-ui/core";
import Image from "next/image";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import facebook from "../../../../../public/assets/images/share/facebook.svg";
import gmail from "../../../../../public/assets/images/share/gmail.svg";
import linkedin from "../../../../../public/assets/images/share/linkedin.svg";
import telegram from "../../../../../public/assets/images/share/telegram.svg";
import whatsapp from "../../../../../public/assets/images/share/whatsapp.svg";
import {
  EmailShareButton,
  FacebookShareButton,
  LinkedinShareButton,
  TelegramShareButton,
  WhatsappShareButton,
} from "react-share";
import { toast } from "react-toastify";

import { useTheme } from "@material-ui/core/styles";
import ShareComponent from "../../../../shareComponent/index";
const useStyles = makeStyles((theme) => ({
  container: {
    width: "100%",
    marginTop: 20,
    backgroundColor: "#fff",
    borderRadius: "10px",
    boxShadow: "0 2px 15px 0 #0001",
  },

  item: {
    padding: 15,
  },
  itemShare: {
    padding: 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "solid 1px #DADADA",
    backgroundColor: "#FFFFFF",
    marginTop: "20px",
    marginBottom: "20px",
    borderRadius: "15px",
  },

  icon: {
    fontSize: 30,
    color: "#B6B3B3",
    marginBottom: "-10px",
    cursor: "pointer",
    [theme.breakpoints.down("md")]: {
      fontSize: 25,
    },
  },

  copy: {
    fontSize: 14,
    padding: "5px 10px",

    display: "inline-block",
    // margin: "0 20px",
    // marginLeft: "20px",
    cursor: "pointer",
    color: "#292929",
    backgroundColor: "#F1EFEF",
    borderRadius: "10px",
    // marginBottom: 10,
  },
  copyIcon: {
    fontSize: 20,
    display: "inline-block",
    marginBottom: "-5px",
    color: "#B6B3B3",
  },
  media: {
    width: 40,
    margin: "0 10px",
    display: "inline-block",
  },
}));
const PaymentPageFooter = ({ data }) => {
  const classes = useStyles();
  const copyToClipboardHandler = () => {
    navigator.clipboard
      .writeText(data?.dedicated_payment_page_share_link)
      .then(() => {
        toast.success("لینک با موفقیت کپی شد");
      });
  };
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <>
      <Grid
        item
        xs={12}
        className={classes.itemShare}
        container
        marginTop={"10px"}
      >
        <Grid item xs={11} md={6}>
          <span className={classes.copy} onClick={copyToClipboardHandler}>
            <ContentCopyIcon className={classes.copyIcon} />{" "}
            {data?.dedicated_payment_page_share_link}
          </span>
        </Grid>
        {!isMobile && (
          <Grid item xs={12} md={6} container justify="flex-end">
            <TelegramShareButton url={data?.dedicated_payment_page_share_link}>
              <Image
                src={telegram}
                width={50}
                alt="telegram"
                className={classes.media}
              />
            </TelegramShareButton>
            <EmailShareButton url={data?.dedicated_payment_page_share_link}>
              <Image
                src={gmail}
                width={50}
                alt="gmail"
                className={classes.media}
              />
            </EmailShareButton>

            <LinkedinShareButton url={data?.dedicated_payment_page_share_link}>
              <Image
                src={linkedin}
                width={50}
                alt="linkedin"
                className={classes.media}
              />
            </LinkedinShareButton>
            <WhatsappShareButton url={data?.dedicated_payment_page_share_link}>
              <Image
                src={whatsapp}
                width={50}
                alt="whatsapp"
                className={classes.media}
              />
            </WhatsappShareButton>
            <FacebookShareButton url={data?.dedicated_payment_page_share_link}>
              <Image
                src={facebook}
                width={50}
                alt="facebook"
                className={classes.media}
              />
            </FacebookShareButton>
          </Grid>
        )}

        {isMobile && (
          <Grid item xs={1} md={6} container>
            <ShareComponent
              url={data?.dedicated_payment_page_share_link}
              title={data?.title}
              text={""}
            />
          </Grid>
        )}
      </Grid>
    </>
  );
};

export default PaymentPageFooter;
